import React from 'react';
import { FormattedMessage } from 'react-intl';

import { SwitchBox } from '../../../molecules/switch-box';
import { ParentPaper } from '../../../atoms/parent-paper';
import { HelpButton } from '../../../atoms/help-button';

export const SettingsSpOverflow = () => {
  return (
    <ParentPaper>
      <SwitchBox
        title={
          <>
            <FormattedMessage
              id="settings.spot.overflow"
              defaultMessage="Povolit optimalizaci přetoku podle spotu"
            />
            <HelpButton
              variant="dialog"
              title={
                <FormattedMessage
                  id="settings.spot.overflow"
                  defaultMessage="Povolit optimalizaci přetoku podle spotu"
                />
              }
              content={
                <FormattedMessage
                  id="settings.spot.overflow.help"
                  defaultMessage="Pokud zvolíte tuto možnost, tak systém upřednostní přetok do sítě před nabíjením baterie v době vyšších a středních spotových cen. Děje se pouze v ročních obdobích, ve kterých předpokládáme přebytek energie z FVE a dochází k tomu zpravidla ráno. Optimalizace neprobíhá v nízkých spotových cenách, kdy je prioritou nabíjení baterie z FVE."
                />
              }
            />
          </>
        }
        switchVariableId="SP_OVERFLOW_OPTIMALIZATION"
        subtitle={
          <FormattedMessage
            id="settings.spot.overflow.subtitle"
            defaultMessage="Umožní upřednostnění přetoku před akumulací"
          />
        }
        visibility={{
          variableIds: ['SP_INSTALL', 'PV_OVERFLOW_CONTROL'],
        }}
        fullWidth
      />
    </ParentPaper>
  );
};
